import { useEffect, useState } from 'react'

import { Button, Modal } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines, faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { selectUser } from '../../reducers/UserReducer'
import { conditionalPromise, resolvePromises } from '../../utils/apiHelper'
import { getInstitutionDocuments } from '../../utils/api/institution'
import { getSectorDocuments } from '../../utils/api/sector'
import { downloadInstitutionDocument } from '../../utils/api/institutionDocument'
import { downloadSectorDocument } from '../../utils/api/sectorDocument'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const StudentFilesModal = ({ visible, internship, onBack, onValidate }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(true)

  const institution = internship?.institution ?? null
  const sector = internship?.sector ?? null

  useEffect(() => {
    if (!visible) {
      return
    }

    setLoading(true)

    const stack = [
      conditionalPromise(() => getInstitutionDocuments(user, institution), institution !== null, [])
        .then(json => (json?.data ?? []).map(file => ({ file, download: () => downloadInstitutionDocument(user, file) }))),
      conditionalPromise(() => getSectorDocuments(user, sector), sector !== null, [])
        .then(json => (json?.data ?? []).map(file => ({ file, download: () => downloadSectorDocument(user, file) })))
    ]

    resolvePromises(stack).then(([institutionDocs, sectorDocs]) => {
      setDocuments([...institutionDocs, ...sectorDocs])
      setLoading(false)
    })
  }, [visible, user, institution, sector])

  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      onCancel={onBack}
      width={520}
    >
      <div className='flex-row ai-ctr' style={{ gap: '16px' }}>
        <div>
          <h3 style={{ margin: 0, fontWeight: 600 }}>
            {t('student_files_modal.title')}
          </h3>
          <p style={{ margin: '4px 0 0', color: '#6b7280' }}>
            {t('student_files_modal.subtitle')}
          </p>
        </div>
      </div>

      <div
        style={{
          marginTop: '24px',
          padding: '16px',
          borderRadius: '8px',
          backgroundColor: '#f7f7f5'
        }}
      >
        <div
          style={{
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.05em',
            color: '#6b7280',
            textTransform: 'uppercase'
          }}
        >
          {t('student_files_modal.documents_available')}
        </div>
        <div className='flex-column' style={{ gap: '8px', marginTop: '12px' }}>
          {!loading && documents.length === 0 && (
            <span style={{ color: '#6b7280' }}>{t('common.none')}</span>
          )}
          {documents.map(({ file, download }) => (
            <a
              key={file.id}
              onClick={download}
              className='flex-row ai-ctr jc-between'
              style={{
                padding: '10px 12px',
                borderRadius: '6px',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb'
              }}
            >
              <span className='flex-row ai-ctr' style={{ gap: '8px' }}>
                <FontAwesomeIcon icon={faFileLines} />
                {file.originalName}
              </span>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </a>
          ))}
        </div>
      </div>

      <hr
        style={{
          margin: '20px 0',
          border: 'none',
          borderTop: '1px solid #e5e7eb'
        }}
      />

      <Button type='primary' style={{ width: '100%', textWrap: 'wrap', height: 'fit-content', padding: '10px 12px' }} size='large' onClick={onValidate}>
        {t('student_files_modal.certify')}
      </Button>
    </Modal>
  )
}

export default StudentFilesModal
